if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        media: this.querySelector('.product__media'),
        video: this.querySelectorAll('.js-video-player'),
        gallerySlider: this.querySelector('.gallery-image-slider')
      }

      // Add resize observer to update container height
      const resizeObserver = new ResizeObserver(entries => this.update());
      resizeObserver.observe(this);
    }
    
    connectedCallback() {
      // Setup video play/pause functionality when element is added to DOM
      this.setupVideoControls();
    }
    
    setupVideoControls() {
      const playButtons = this.querySelectorAll('.product__media-play-button');
      
      playButtons.forEach(button => {
        const videoContainer = button.closest('.product-media-container');
        if (!videoContainer) return;
        
        const video = videoContainer.querySelector('.js-video-player');
        if (!video) return;
        
        const playIcon = button.querySelector('.icon-play-button');
        const pauseIcon = button.querySelector('.icon-pause-button');
        
        // Update button state based on video playing state
        const updateButtonState = () => {
          if (video.paused) {
            playIcon?.classList.remove('hidden');
            pauseIcon?.classList.add('hidden');
            button.setAttribute('aria-label', button.dataset.playLabel || 'Play video');
          } else {
            playIcon?.classList.add('hidden');
            pauseIcon?.classList.remove('hidden');
            button.setAttribute('aria-label', button.dataset.pauseLabel || 'Pause video');
          }
        };
        
        // Initialize button state
        updateButtonState();
        
        // Handle button click
        button.addEventListener('click', (e) => {
          e.preventDefault();
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
          
          updateButtonState();
        });
        
        // Listen to video events to keep button state in sync
        video.addEventListener('play', updateButtonState);
        video.addEventListener('pause', updateButtonState);
        video.addEventListener('ended', updateButtonState);
      });
    }
    
    update() {
      this.elements = {
        media: this.querySelector('.product__media'),
        gallerySlider: this.querySelector('.gallery-image-slider')
      };

      const media = this.elements.media;
      if (!media) return;

      const height = media.offsetHeight;
      if (height <= 0) return; // avoid infinite retries

      if (this.elements.gallerySlider)
        this.elements.gallerySlider.style.height = `${height}px`;
    }
  });
}
